module.exports = __webpack_public_path__ + "static/media/attachmentsLight.2ebb72e7.svg";